export const STAGES = [
  { key: "abertura", label: "Triagem", short: "Triagem" },
  { key: "t1_triagem", label: "T1 · Triagem", short: "T1" },
  { key: "t2_atendimento_interno", label: "T2 · Atendimento Interno Zitec", short: "T2" },
  { key: "t3_responsavel_tecnico", label: "T3 · Responsável Técnico", short: "T3" },
  { key: "resolucao", label: "Fechado", short: "Fechado" },
];

export const ROLES = [
  { key: "atendente", label: "Atendente" },
  { key: "t1_triagem", label: "T1 · Triagem" },
  { key: "t2_atendimento_interno", label: "T2 · Atendimento Interno" },
  { key: "t3_responsavel_tecnico", label: "T3 · Responsável Técnico" },
  { key: "gestor", label: "Gestor" },
];

export const PRIORIDADES = [
  { key: "baixa", label: "Baixa" },
  { key: "media", label: "Média" },
  { key: "alta", label: "Alta" },
  { key: "critica", label: "Crítica" },
];

export const ORIGENS = [
  { key: "portal", label: "Portal" },
  { key: "whatsapp", label: "WhatsApp" },
  { key: "email", label: "E-mail" },
  { key: "slack", label: "Slack" },
  { key: "webhook", label: "Webhook / API" },
  { key: "outros", label: "Outros" },
];

// O nível T1 leva o nome da marca (Customização); o ThemeProvider chama isto ao carregar/alterar o nome.
export const applyBrandName = (name) => {
  const label = `T1 · ${name?.trim() || "Triagem"}`;
  STAGES.find((s) => s.key === "t1_triagem").label = label;
  ROLES.find((r) => r.key === "t1_triagem").label = label;
};

export const stageLabel = (k) => STAGES.find((s) => s.key === k)?.label || k;
// "slack": comentário que chegou de uma resposta na thread do Slack
export const roleLabel = (k) => (k === "slack" ? "Slack" : ROLES.find((r) => r.key === k)?.label || k);

// Conversa do chamado no Slack (slack:T…:C…:thread_ts:U…): o usuário U… é quem abriu, usado na menção rápida
export const slackThread = (ref) => {
  const m = /^slack:(T\w+):([CDG]\w+):([\d.]+)(?::(U\w+))?$/.exec(ref || "");
  return m ? { team: m[1], channel: m[2], ts: m[3], user: m[4] || null } : null;
};
export const prioLabel = (k) => PRIORIDADES.find((p) => p.key === k)?.label || k;
export const origemLabel = (k) => ORIGENS.find((o) => o.key === k)?.label || k;

// Link para a conversa de origem no Slack (origem_ref gravada pelo n8n):
// "slack:T…:C…:ts:U…" (conversa do chamado no canal) e "slack:T…:D…" (ou C…/G…) abrem o canal no app do Slack;
// "slack:T…:U…" (chamados antigos) abre o perfil do usuário;
// um permalink https://….slack.com/… abre a mensagem
export const slackLink = (ref) => {
  if (!ref) return null;
  if (/^https:\/\/[\w-]+\.slack\.com\//.test(ref)) return ref;
  // Conversa do chamado: link da mensagem de abertura (raiz da thread). slack.com/archives sem o subdomínio
  // redireciona para o workspace de quem está logado
  const th = slackThread(ref);
  if (th) return `https://slack.com/archives/${th.channel}/p${th.ts.replace(".", "")}`;
  const m = /^slack:(T\w+):([CDGUW])(\w+)(?::[\d.]+(?::\w*)?)?$/.exec(ref);
  if (!m) return null;
  const tipo = "CDG".includes(m[2]) ? "channel" : "user";
  return `slack://${tipo}?team=${m[1]}&id=${m[2]}${m[3]}`;
};

export const fmtDate =(iso) => (iso ? new Date(iso).toLocaleString("pt-BR") : "—");
export const uid = () => (crypto.randomUUID ? crypto.randomUUID() : String(Date.now() + Math.random()));

// Prazo (SLA) em horas por prioridade + fração do prazo que dispara o alerta.
// Valores padrão; o StoreContext aplica a configuração salva na API (GET /api/settings/sla).
export const DEFAULT_SLA = { hours: { critica: 4, alta: 8, media: 24, baixa: 72 }, warn_ratio: 0.25 };
export const SLA_HOURS = { ...DEFAULT_SLA.hours };
let WARN_RATIO = DEFAULT_SLA.warn_ratio;
export const applySlaConfig = (cfg) => {
  Object.assign(SLA_HOURS, DEFAULT_SLA.hours, cfg?.hours);
  WARN_RATIO = cfg?.warn_ratio || DEFAULT_SLA.warn_ratio;
};

const fmtDur = (ms) => {
  const m = Math.floor(Math.abs(ms) / 60000);
  const d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
  return d ? `${d}d ${h}h` : h ? `${h}h ${mm}m` : `${mm}m`;
};

export const slaInfo = (t, now = Date.now()) => {
  const total = (SLA_HOURS[t.prioridade] || 24) * 36e5;
  const start = new Date(t.created_at).getTime();
  const deadline = start + total;
  const end = t.resolved_at ? new Date(t.resolved_at).getTime() : now;
  const left = deadline - end;
  let state;
  if (t.resolved_at) state = left >= 0 ? "met" : "missed";
  else state = left < 0 ? "breached" : left <= total * WARN_RATIO ? "warning" : "ok";
  const label = {
    met: "Cumprido", missed: `Estourou ${fmtDur(left)}`,
    breached: `Atrasado ${fmtDur(left)}`, warning: `Restam ${fmtDur(left)}`, ok: `Restam ${fmtDur(left)}`,
  }[state];
  return { state, left, deadline: new Date(deadline).toISOString(), label, pct: Math.max(0, Math.min(100, ((end - start) / total) * 100)) };
};
